import { AbstractFault, Fault } from "@app/shared";

@Fault('Modutecture.Shared.DTOsV2.ProgramAlreadyExistsFault, Modutecture.Shared')
export class ProgramAlreadyExistsFault extends AbstractFault {
    public name: string;
}

@Fault('Modutecture.Shared.DTOsV2.ProjectAlreadyExistsFault, Modutecture.Shared')
export class ProjectAlreadyExistsFault extends AbstractFault {
    public name: string;
}


@Fault('Modutecture.Shared.DTOsV2.RoomAlreadyExistsFault, Modutecture.Shared')
export class RoomAlreadyExistsFault extends AbstractFault {
    public code: string;
}


@Fault('Modutecture.Shared.DTOsV2.DepartmentAlreadyExistsFault, Modutecture.Shared')
export class DepartmentAlreadyExistsFault extends AbstractFault {
    public code: string;
}
